import { useState, useCallback } from "react";
import { toast } from "react-toastify";
import {
    getAIResponse,
    storeChatMessage,
    getConditionSummary,
    parseAIResponse
} from "../../services/consultationService";
import { formatTimestamp } from "../../utils/TimeFormatter";
// import { speakLiveAvatar } from "../services/liveAvatarService";

export const useConsultation = ({ consultationId, userId, headers, speakAvatar }) => {
    console.log({ consultationId, userId })
    const [isResponsePending, setResponsePending] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);
    const [consultationSections, setConsultationSections] = useState([]);
    const [isAITyping, setIsAITyping] = useState(false);

    const sendMessage = async (message, setChatMessages, onResponse) => {
        if (!message.trim() || !consultationId) return;

        const userMsg = {
            id: Date.now(),
            text: message,
            isUser: true,
            timestamp: formatTimestamp(new Date())
        };
        setChatMessages((prev) => [...prev, userMsg]);
        setResponsePending(true);

        const tempId = Date.now() + 1;
        setChatMessages((prev) => [
            ...prev,
            {
                id: tempId,
                text: "Thinking...",
                isUser: false,
                timestamp: formatTimestamp(new Date()),
            },
        ]);
        try {
            await storeChatMessage(consultationId, message, true, headers);
            const responseData = await getAIResponse(message, consultationId, userId, headers);

            if (responseData && responseData.response) {
                const aiMessage = responseData.response;
                await speakAvatar(aiMessage)
                setChatMessages((prev) =>
                    prev.map((msg) =>
                        msg.id === tempId ?
                            {
                                ...msg,
                                text: "",
                                fullText: aiMessage,
                                isTyping: true,
                            }
                            :
                            msg,
                    ),
                );
                setIsAITyping(true);
                if (onResponse) onResponse(aiMessage);
                if (aiMessage.toLowerCase().includes("do you still have any other queries?") && message.toLowerCase() === "no") {
                    setIsCompleted(true);
                    await fetchSummary();
                }

                setTimeout(async () => { await storeChatMessage(consultationId, aiMessage, false, headers); }, 500);
            }
        } catch (error) {
            console.error("AI response error:", error);
            toast.error("AI response failed.");
            setChatMessages((prev) =>
                prev.map((msg) =>
                    msg.id === tempId ? { ...msg, text: "Error processing request", isTyping: false } : msg,
                ),
            );
        }
        finally { setResponsePending(false) }
    };
    const fetchSummary = async () => {
        if (!consultationId || !userId) return;
        try {
            const data = await getConditionSummary(consultationId, userId, headers);
            if (data) {
                const parsedSections = parseAIResponse(data);
                if (parsedSections && parsedSections.length > 0) { setConsultationSections(parsedSections); }
            }
        }
        catch (error) { console.error("Error fetching summary:", error) }
    };

    return {
        sendMessage,
        isResponsePending,
        isCompleted,
        setIsCompleted,
        consultationSections,
        setConsultationSections,
        fetchSummary,
        isAITyping,
        setIsAITyping
    };
};